import { Box, Image } from '@bonanza-social/moonlight';
import RewardCard from './RewardCard/RewardCard';
import { RewardCardType } from './RewardCard/RewardCard.types';
import RewardCardHorizontal from './RewardCard/RewardCardHorizontal';
import { RegistrationVariantEnum } from '../../utils/fetchRegistrationVariant';

export type PromotionT = React.ComponentProps<
  typeof RewardCardHorizontal
>['promotion'];

type VariantProps = {
  referralPromo?: PromotionT | null;
  selectedWelcomePromo?: PromotionT | null;
  isSelectedPromoReferral: boolean;
};

export const VARIANTS = {
  [RegistrationVariantEnum.threeStep]: ({
    referralPromo,
    selectedWelcomePromo,
    isSelectedPromoReferral,
  }: VariantProps) => {
    if (!referralPromo && !selectedWelcomePromo) return null;

    return (
      <Box
        backgroundColor="secondaryBackgroundDefault"
        borderRadius="radius-200"
        flexDirection="row"
      >
        {referralPromo ? (
          <Box position="relative" flex={1} flexDirection="row" zIndex={1}>
            <RewardCardHorizontal
              containerProps={{ flex: 1 }}
              type={RewardCardType.REFERRER}
              promotion={referralPromo}
              referralPromo={referralPromo}
            />
          </Box>
        ) : null}

        {selectedWelcomePromo && referralPromo && !isSelectedPromoReferral ? (
          <Image
            name="common.plus"
            color="accentSurfaceDisabled"
            width={{ mobile: 30, tablet: 45, desktop: 45 }}
            marginHorizontal="space-200"
          />
        ) : null}

        {selectedWelcomePromo && !isSelectedPromoReferral ? (
          <RewardCardHorizontal
            containerProps={{ flex: 1 }}
            type={RewardCardType.WELCOME}
            promotion={selectedWelcomePromo}
            referralPromo={referralPromo}
          />
        ) : null}
      </Box>
    );
  },

  [RegistrationVariantEnum.elevenStep]: ({
    referralPromo,
    selectedWelcomePromo,
    isSelectedPromoReferral,
  }: VariantProps) => {
    if (!referralPromo && !selectedWelcomePromo) return null;

    return (
      <>
        <Box position="relative" zIndex={1}>
          {referralPromo ? (
            <RewardCard
              type={RewardCardType.REFERRER}
              promotion={referralPromo}
            />
          ) : null}

          {selectedWelcomePromo && referralPromo && !isSelectedPromoReferral ? (
            <Image
              position="absolute"
              transform="translate(7px, 40px)"
              name="common.plus"
              zIndex={99999}
              width={45}
              height={45}
            />
          ) : null}
        </Box>

        {selectedWelcomePromo && !isSelectedPromoReferral ? (
          <RewardCard
            type={RewardCardType.WELCOME}
            promotion={selectedWelcomePromo}
          />
        ) : null}
      </>
    );
  },
};
